import React, { Fragment } from "react";
import Header2 from "../../components/header/Header2";
import { Link } from "react-router-dom";
import Scrollbar from "../../components/WhatsAppBtn/WhatsAppBtn";
import CtaSection from "../../components/CtaSection/CtaSection";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import icon from "../../images/icon/eye-icon.svg";
import caseImg from "../../images/testimonial/sa-tes03.jpg";
import cIcon1 from "../../images/icon/csd-icon01.svg";
import cIcon2 from "../../images/icon/csd-icon02.svg";
import cIcon3 from "../../images/icon/csd-icon03.svg";
import cIcon4 from "../../images/icon/csd-icon04.svg";
import cIcon from "../../images/icon/check-icon.svg";
import caseStudies from "../../api/case";

const CaseStudyDatacenterVirtual = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header2 />
        <section
          className="page-title pt-200 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap">
              <div className="row mt-none-30 align-items-end">
                <div className="col-lg-9 mt-30">
                  <div className="page-title-box">
                    <span className="sub-title">
                      <img src={icon} alt="" /> Caso de Sucesso
                    </span>
                    <h2 className="title">
                      Datacenter Virtual para Logística <br /> aumentando
                      capacidade em 200% <br /> e reduzindo provisionamento em
                      60%
                    </h2>
                  </div>
                </div>
                <div className="col-lg-3 mt-30">
                  <div className="count-box">
                    <h2 className="number">
                      200<span className="suffix">%</span>
                    </h2>
                    <span className="text">
                      aumento de capacidade <br /> de processamento
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="csd-img pt-70 pb-65">
          <div className="container">
            <div className="item-details_image pos-rel">
              <img
                src={caseImg}
                alt="Datacenter Virtual - Empresa de Logística"
              />
            </div>
          </div>
        </div>
        <div className="sd-ser-content_wrap pb-90">
          <div className="container">
            <div className="sd-ser-content">
              <h2 className="sd-title">
                O desafio: escalabilidade limitada em operação 24/7
              </h2>
              <p className="sd-content">
                Uma empresa de logística com operação nacional enfrentava sérios
                gargalos de infraestrutura. Com mais de 50 filiais conectadas,
                sistemas de WMS (Warehouse Management System), TMS
                (Transportation Management System) e rastreamento em tempo real,
                a empresa precisava processar milhões de transações diárias. A
                infraestrutura local não conseguia acompanhar o crescimento
                exponencial, resultando em lentidão nos sistemas durante picos
                de demanda.
              </p>
              <br />
              <p className="sd-content">
                O problema se intensificou durante a Black Friday, quando o
                volume de pedidos aumentou 400% e os sistemas ficaram
                indisponíveis por 4 horas. Isso resultou em atrasos na entrega,
                insatisfação dos clientes e multas contratuais de R$ 2,3
                milhões. A empresa precisava de uma solução que oferecesse
                escalabilidade automática, alta performance e disponibilidade
                24/7 para suportar o crescimento acelerado do e-commerce.
              </p>
            </div>
          </div>
        </div>
        <div className="csd-ser_warp">
          <div className="container">
            <div className="csd-ser_inner ul_li_between">
              <div className="csd-item ul_li">
                <div className="xb-icon">
                  <img src={cIcon1} alt="" />
                </div>
                <h6 className="xb-text">
                  cliente : <span> Empresa de Logística Nacional</span>
                </h6>
              </div>
              <div className="csd-item ul_li">
                <div className="xb-icon">
                  <img src={cIcon2} alt="" />
                </div>
                <h6 className="xb-text">
                  serviços : <span> Datacenter Virtual + Auto-scaling</span>
                </h6>
              </div>
              <div className="csd-item ul_li">
                <div className="xb-icon">
                  <img src={cIcon3} alt="" />
                </div>
                <h6 className="xb-text">
                  conclusão : <span> 45 dias</span>
                </h6>
              </div>
              <div className="csd-item ul_li">
                <div className="xb-icon">
                  <img src={cIcon4} alt="" />
                </div>
                <h6 className="xb-text">
                  localização : <span> Nacional, Brasil</span>
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div className="sd-service_wrap pt-90 pb-130">
          <div className="container">
            <div className="sd-ser-outcome">
              <div className="sd-heading">
                <h2 className="sd-title">Requisitos do projeto</h2>
                <p className="sd-content">
                  O cliente necessitava de uma solução que oferecesse
                  escalabilidade automática baseada em demanda, alta performance
                  para sistemas críticos de logística, integração com sistemas
                  legados (WMS/TMS), backup e disaster recovery automático, além
                  de monitoramento em tempo real de toda a infraestrutura.
                </p>
              </div>
              <div className="sd-list-item ul_li">
                <ul className="sd-ser-list list-unstyled">
                  <li>
                    <img src={cIcon} alt="" />
                    Análise de carga e dimensionamento
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Arquitetura de auto-scaling inteligente
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Migração de sistemas WMS/TMS
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Otimização de banco de dados
                  </li>
                </ul>
                <ul className="sd-ser-list list-unstyled">
                  <li>
                    <img src={cIcon} alt="" />
                    Implementação de CDN para rastreamento
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Monitoramento de performance em tempo real
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Backup automático multi-região
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Integração com APIs de transportadoras
                  </li>
                </ul>
              </div>
            </div>
            <div className="sd-heading csd-heading pt-90">
              <h2 className="sd-title">Solução implementada & resultados</h2>
              <p className="sd-content">
                <span>Solução:</span> Implementamos um datacenter virtual
                completo com arquitetura de auto-scaling baseada em métricas de
                CPU, memória e requisições por segundo. A solução incluiu
                otimização de banco de dados, implementação de cache
                distribuído, CDN para rastreamento de entregas e integração com
                APIs de transportadoras. Configuramos monitoramento proativo com
                alertas automáticos e dashboard executivo em tempo real.
              </p>
              <br />
              <p className="sd-content">
                <span>Resultados:</span> A empresa alcançou 200% de aumento na
                capacidade de processamento, 60% de redução no tempo de
                provisionamento de recursos e 85% de economia com licenciamento
                de software. Durante a próxima Black Friday, os sistemas
                suportaram picos de 800% sem degradação de performance. O tempo
                de resposta médio melhorou de 3,2 segundos para 0,8 segundos, e
                a disponibilidade chegou a 99.95%. A solução permitiu que a
                empresa expandisse para 30 novas filiais sem investimento
                adicional em infraestrutura.
              </p>
            </div>

            <div className="similar-casestudy pt-80">
              <h2 className="similar-casestudy-title">Casos similares</h2>
              <div className="row mt-none-30">
                {caseStudies.slice(4, 7).map((cases, citem) => (
                  <div className="col-lg-4 col-md-6 mt-30" key={citem}>
                    <div className="casestudy-item">
                      <div className="casestudy-img">
                        <Link
                          onClick={ClickHandler}
                          to={`/casestudy-details/${cases.slug}`}
                        >
                          <img src={cases.img} alt="" />
                        </Link>
                        <div className="content_wrap">
                          <h3 className="item_title">{cases.title}</h3>
                          <span className="item_tag">{cases.slug}</span>
                        </div>
                      </div>
                      <Link
                        onClick={ClickHandler}
                        to={`/casestudy-details/${cases.slug}`}
                        className="xb-overlay"
                      ></Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default CaseStudyDatacenterVirtual;
